import React from 'react';
import '@vkontakte/vkui/dist/vkui.css';
import Home from './panels/Home';
import Puzzle from "./panels/Puzzle/Puzzle";
import { AdaptivityProvider, AppRoot, ConfigProvider, Root } from "@vkontakte/vkui";
import bridge from "@vkontakte/vk-bridge";

import './App.css';
import Quiz from "./panels/Puzzle/Quiz";
import City from "./panels/Puzzle/City";
import Nature from "./panels/Puzzle/Nature";
import Space from "./panels/Puzzle/Space";

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {activeView: 'home', activeStory: 'puzzle', game: null, records: null};
    this.scrolls = {puzzle: 0, quiz: 0, city: 0, nature: 0};
  }

  componentDidMount() {
    window.addEventListener('scroll', () => {
      this.scrolls[this.state.activeStory] = window.scrollY;
    });
  }

  go = e => {
    let to = (e !== undefined) ? e.currentTarget.dataset.to : 'home';
    this.setState({...this.state, activeView: to});
  };

  setGame = (type, item) => {
    this.setState({...this.state, activeView: type, game: item});
  };

  onStoryChange = (e) => {
    this.setState({...this.state, activeStory: e.currentTarget.dataset.story}, () => {
      window.scrollTo(0, this.scrolls[this.state.activeStory]);
    })
  }

  onLoadRecords = (keys) => {
    this.setState({...this.state, records: {}}, () => {
      bridge.send('VKWebAppStorageGet', {'keys': keys})
        .then(data => {
          let records = data.keys.reduce((acc, obj) => {
            if (obj.value) {
              acc[obj.key] = obj.value;
            }
            return acc;
          }, {});
          this.setState({...this.state, records: records});
        })
        .catch(error => {
          console.log(error);
        });
    });
  };

  onSetRecord = (key, value) => {
    let toSeconds = (time) => {
      return time.split(':').reverse().reduce((acc, val, index) => {return acc + val*(60**index)}, 0);
    };
    let current = this.state.records[key];
    if ((!current) || (current && (toSeconds(value) < toSeconds(current)))) {
      let records = this.state.records;
      records[key] = value;
      this.setState({...this.state, records: records}, () => {
        bridge.send('VKWebAppStorageSet', {key: key, value: value});
      });
    }
  };

  render() {
		return <ConfigProvider><AdaptivityProvider><AppRoot><Root activeView={this.state.activeView}>
      <Home id='home' setGame={this.setGame} activeStory={this.state.activeStory} onStoryChange={this.onStoryChange} records={this.state.records} onLoadRecords={this.onLoadRecords}/>
      <Puzzle id='puzzle' go={this.go} {...this.state.game} onSetRecord={this.onSetRecord} />
      <Quiz id='quiz' go={this.go} {...this.state.game} onSetRecord={this.onSetRecord} />
      <City id='city' go={this.go} {...this.state.game} onSetRecord={this.onSetRecord} />
      <Nature id='nature' go={this.go} {...this.state.game} onSetRecord={this.onSetRecord} />
      <Space id='space' go={this.go} {...this.state.game} onSetRecord={this.onSetRecord} />
    </Root></AppRoot></AdaptivityProvider></ConfigProvider>;
  }
}

export default App;

